import styled from "styled-components";


export const ContentInputsWithBorder = styled.div`
  display: flex;
  flex-direction: column;
`;
